<div [ngClass]="showing ? 'keyboard' : 'keyboard hidden'">
  <div class="column left">
    <div class="row" (click)="keyPressed('1')">
      1
    </div>
    <div class="row" (click)="keyPressed('4')">
      4
    </div>
    <div class="row" (click)="keyPressed('7')">
      7
    </div>
    <div class="row" (click)="keyPressed('.')">
      .
    </div>
  </div>
  <div class="column">
    <div class="row" (click)="keyPressed('2')">
      2
    </div>
    <div class="row" (click)="keyPressed('5')">
      5
    </div>
    <div class="row" (click)="keyPressed('8')">
      8
    </div>
    <div class="row" (click)="keyPressed('0')">
      0
    </div>
  </div>
  <div class="column">
    <div class="row" (click)="keyPressed('3')">
      3
    </div>
    <div class="row" (click)="keyPressed('6')">
      6
    </div>
    <div class="row" (click)="keyPressed('9')">
      9
    </div>
    <div class="row flex" (click)="hide()">
      <mat-icon class="keyboard-icon" >keyboard</mat-icon>
    </div>
  </div>
  <div class="column">
    <div class="row double flex" (click)="backspace()">
      <mat-icon class="backspace-icon">backspace</mat-icon>
    </div>
    <div [ngClass]="canSubmit ? 'row double submit flex' : 'row double submit flex disabled'" (click)="submit()">
      <mat-icon class="submit-icon" >done</mat-icon>
    </div>
  </div>
</div>